import * as filestack from 'filestack-js';
import { environment } from '~/environments';
import { IMG_CONFIG } from './constants';

export class FilestackService {
  /**
   * Optimized combination for compressing the product images gallery
   * without losing quality. Every time quality and width value is changed,
   * Filestack counts it as new transformation, what might affect our quota.
   * Be aware of it when playing with these values.
   */
  private DEFAULT_IMAGE_CACHE_DURATION = 60 * 60 * 24 * 30 * 12; // 12 months

  /**
   * product domains are whitelisted in the Filestack dashboard
   * to ensure the security of the api key that is exposed here
   */
  private FILESTACK_BASE_URL = 'https://cdn.filestackcontent.com';

  private getTransformationUrl = ({
    height,
    quality,
    width,
  }: {
    height?: number;
    quality: number;
    width?: number;
  }) => {
    const resizeParts = [
      width !== undefined && `width:${width}`,
      height !== undefined && `height:${height}`,
    ].filter(Boolean);
    const resizeSegment = resizeParts.length
      ? `resize=${resizeParts.join(',')}`
      : '';
    const transformationPath = `cache=expiry:${this.DEFAULT_IMAGE_CACHE_DURATION}/${resizeSegment}/output=format:webp,quality:${quality}`;

    return `${this.FILESTACK_BASE_URL}/${environment.filestackApiKey}/${transformationPath}`;
  };

  uploadFile = async (file: File): Promise<string> => {
    const client = filestack.init(environment.filestackApiKey);
    const res = await client.upload(file);
    return res.url;
  };

  optimizeImage = (
    url: string | undefined,
    config: {
      height?: number;
      quality: number;
      width?: number;
    } = IMG_CONFIG.default,
  ) => {
    if (!url) return undefined;

    return `${this.getTransformationUrl(config)}/${url}`;
  };
}

export const filestackService = new FilestackService();
